import { IconButton, IconButtonProps, Tooltip } from "@chakra-ui/react";
import { FaSyncAlt } from "react-icons/fa";
export default function ResetMapButton(props: Partial<IconButtonProps>) {
  return (
    <Tooltip
      label="Reset Map"
      fontSize="xs"
      hasArrow
      placement="left"
      shouldWrapChildren
    >
      <IconButton
        aria-label="Reset Map"
        _focus={{ outline: "none" }}
        icon={<FaSyncAlt />}
        size="sm"
        bg={"white"}
        color="text"
        {...props}
      />
    </Tooltip>
  );
}
